export const TENANT_MANAGEMENT_PREFIX = 'TENANT_MANAGEMENT_PREFIX_';

export const SEARCH_REFRESH = TENANT_MANAGEMENT_PREFIX + 'SEARCH_REFRESH';

export const FETCH_STATE_LIST = TENANT_MANAGEMENT_PREFIX + 'FETCH_STATE_LIST';
